import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles, WithStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import color from '../../utils/colors';
import { Link, RouteComponentProps } from 'react-router-dom';
import CategoryName from '../shared/CategoryName';

export const styles = (theme: Theme) => {
	return ({
		listItem: {
			background: color.darkBackground,
			color: theme.palette.primary.main,
			'&:hover': {
				background: color.darkBackground,
			},
		},
		list: {
			background: color.darkBackground,
			height: '100%',
			padding: 'initial',
		},
		listItemText: {
			background: color.darkBackground,
			color: 'white',
			fontSize: 30,
			textTransform: 'uppercase' as "uppercase",
		}
	});
}


export interface CategoryListProps {
	setScrollPosition: () => void
	categories: string[];
}

export type CategoryListAllProps = CategoryListProps
	& WithStyles
	& RouteComponentProps<any>;

export const CategoryListComponent: React.FunctionComponent<CategoryListAllProps> = (
	{
		categories,
		classes,
		location: { pathname },
		setScrollPosition,
	}
) => {

	if (!categories.length) {
		return null;
	}

	return (
		<section id="category-list" className="full-height">
			<List component="ul" classes={{ root: classes.list }}>
				{categories.map((category: string, index: number) => {
					return (
						<ListItem component="li" classes={{ root: classes.listItem }} button key={`category-${index}`}>
							<Link to={`${pathname}/${index}`} onClick={setScrollPosition}>
								<ListItemText
									classes={{ primary: classes.listItemText }}
									primary={
										<CategoryName text={category} />
									} />
							</Link>
						</ListItem>
					);
				})}
			</List>
		</section>
	);
}

export default withStyles(styles)(CategoryListComponent);
